// extracted by css-extract-rspack-plugin
export default {"UpsellBannerComponent":"zaG9g","Large":"TNwkp"};